import React from "react";
import Badge from "../common/Badge";
import { isSupernovaBuyEnabled } from "../../config/supernovaFlags";

/**
 * "Get more Supernovas" — the acquire SEAM, and deliberately nothing more.
 *
 * TODO(buy-mint, supervised): there is no buy or mint path in this app. No
 * venue, no price feed, no checkout, no mint calldata, no marketplace link, and
 * no transaction of any kind — supernovaChain.acquire() throws for exactly this
 * reason. The whole surface sits behind SUPERNOVA_BUY_ENABLED (default OFF) and
 * ships under human supervision, because acquiring an NFT is a money path.
 *
 * WHY IT EXISTS AT ALL WITH THE FLAG OFF: a member whose wallet holds nothing,
 * or who wants a second strategy slot, will look for this. A labelled
 * "coming soon" is a truthful answer; silence sends them to a search engine and
 * whatever it turns up. It states the position and offers no action.
 *
 * FLAG ON is not "shippable" either — it reveals the seam, not a purchase. The
 * flag-on branch says so in as many words rather than pretending a path exists.
 *
 * COMPLIANCE: no price, no currency, no return, no yield, no income, and no
 * suggestion that acquiring one is an investment. Educational framing only.
 */
const SupernovaAcquire = () => {
  const buyEnabled = isSupernovaBuyEnabled();

  return (
    <div className="sn-seam" data-testid="supernova-acquire">
      <Badge tone="warn" className="uppercase tracking-[0.1em] text-[10px]">
        Coming soon
      </Badge>

      <b className="sn-seam-title mt-2.5">More doors are coming</b>

      <p className="text-[13.5px] text-arc-ink-3 max-w-md mx-auto leading-[1.6]">
        Each Supernova you stake unlocks one more automated strategy slot. There
        is no way to buy or mint one from this app: no venue, no pricing, and no
        checkout is wired up.{" "}
        {buyEnabled ? (
          <>
            The{" "}
            <span className="font-mono text-[11.5px] text-arc-ink-2">
              SUPERNOVA_BUY_ENABLED
            </span>{" "}
            flag is on in this build, which reveals this seam — it does not add a
            purchase path. Nothing here can spend anything.
          </>
        ) : (
          <>
            Seamed off behind{" "}
            <span className="font-mono text-[11.5px] text-arc-ink-2">
              SUPERNOVA_BUY_ENABLED
            </span>{" "}
            until a buy/mint flow ships.
          </>
        )}
      </p>

      <p className="text-caption text-arc-ink-4 mt-2 max-w-md mx-auto leading-[1.55]">
        If and when it does, it will be a transaction you sign in your own wallet
        — ARC Educational never holds your keys, your NFTs, or your funds.
        Supernovas are access passes to educational tooling, not an investment.
      </p>
    </div>
  );
};

export default SupernovaAcquire;
